export default __webpack_public_path__ + "static/media/Merch-Store-GIF-Animation---Transparent (1).eaff25a4.gif";